import { Component, ViewEncapsulation, OnInit } from "@angular/core";
import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";

@Component({
    selector: "formly-field-toggle-view",
    template: `
        <div class="py-6">
            <mat-button-toggle-group
                [value]="selectedViewValue"
                (valueChange)="onViewChange($event)"
                class="w-full v2-button-toggle accent"
            >
                <mat-button-toggle
                    *ngFor="let view of field.fieldGroup; let i = index"
                    [value]="view.templateOptions.value || view.key || i"
                    [class]="view.templateOptions.class || 'w-full'"
                >
                    {{ view.templateOptions.label }}
                </mat-button-toggle>
            </mat-button-toggle-group>
            <!-- <button (click)="addNewTab()">Add New Tab</button> -->
        </div>

        <div>
            <ng-container *ngFor="let view of field.fieldGroup; let i = index">
                <div *ngIf="selectedViewValue === (view.templateOptions.value || view.key || i)">
                    <formly-field [field]="view"></formly-field>
                </div>
            </ng-container>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
})
export class FormlyFieldToggleView extends FieldType implements OnInit {
    selectedViewValue: string;

    tabCount: number = 0;

    isValid(field: FormlyFieldConfig) {
        if (field.key) {
            return field.formControl.valid;
        }

        return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
    }

    ngOnInit(): void {
        if (this.field.fieldGroup && this.field.fieldGroup.length > 0) {
            this.tabCount = this.field.fieldGroup.length;
            const defaultView = this.field.fieldGroup.find((f) => f.templateOptions?.["value"]);
            this.selectedViewValue = defaultView ? defaultView.templateOptions["value"] : null;

            if (!this.selectedViewValue) {
                this.selectedViewValue = String(this.field.fieldGroup[0].key);
            }
        }
    }

    addNewTab() {
        this.tabCount++;
        const newTabKey = `dynamicTab${this.tabCount}`;

        const newTabConfig: FormlyFieldConfig = {
            templateOptions: {
                label: `Tab ${this.tabCount} (New)`,
                value: newTabKey,
            },
            fieldGroup: [
                {
                    key: `${newTabKey}Input`,
                    type: "input",
                    templateOptions: { label: `Input for ${newTabKey}` },
                },
            ],
        };
        this.field.fieldGroup.push(newTabConfig);
        this.selectedViewValue = newTabKey;
    }

    onViewChange(value: string) {
        this.selectedViewValue = value;
    }
}
